<div>
  <div class="container">
    <form class="form__membro" [formGroup]="membroForm" novalidate="novalidate">
      <div class="contatos justify-content-center">
        <div class="row mb-3">
          <div class="col-12">
            <h3 class="lovers-font--bold font-size--32">
              Confirme os seus dados
            </h3>
            <p>
              Para continuar participando do programa, precisamos da confirmação
              dos seus dados.
            </p>
          </div>
        </div>

        <div class="row mb-3" *ngIf="menorQueDataLimite">
          <div class="col-12">
            <h3 class="lovers-font--bold font-size--16">Dados Pessoais</h3>
            <div class="lovers-input__container">
              <label for="dataNascimento" class="lovers-label lovers-font--bold"
                >Data de nascimento</label
              >
              <input
                type="text"
                class="lovers-input input-data"
                formControlName="dataNascimento"
                mask="00/00/0000"
                placeholder="00/00/0000"
                id="dataNascimento"
                (blur)="validaDataNasc()"
              />
            </div>
            <div class="pl-1" *ngIf="membro && exibirDataVazio">
              <small class="text-danger lovers-font--bold">
                Data máxima atingida
              </small>
            </div>
            <!-- <div *ngIf="membroForm.get('dataNascimento').invalid && membroForm.get('dataNascimento').errors.dataInvalida">
              <p class="error--messsage">
                Data máxima atingida.
              </p>
            </div> -->
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <h3 class="lovers-font--bold font-size--16">Contato</h3>
            <p>Valide um dos seus dados de contato.</p>
            <div class="lovers-input__container">
              <label for="telefone" class="lovers-label lovers-font--bold"
                >CELULAR</label
              >
              <input
                type="text"
                class="lovers-input input--ajust"
                pattern="[0-9]*"
                inputmode="numeric"
                mask="(00) 00000-0000"
                formControlName="telefone"
                id="telefone"
              />
              <a
                *ngIf="!membro.telefoneValidado"
                class="label--cod mt-2 ml-1 font-ativa font-12 lovers-font--bold"
                (click)="exibirPopupValidacaoDados(CAMPO_TELEFONE)"
                (keyup)="alteracaoTelefone()"
              >
                <!-- <img
                  class="opcao__icone mr-1"
                  style="width: 10px; height: 14px"
                  src="assets/images/icons/checklist.png"
                /> -->
                Enviar código &nbsp;
              </a>
              <p
                *ngIf="membro.telefoneValidado"
                style="cursor: auto"
                class="mt-2 ml-1 text-success font-14 lovers-font--bold"
              >
                <i class="fa fa-check"></i> Celular validado
              </p>
            </div>
            <div
              class="pl-1"
              *ngIf="
                membroForm.get('telefone').invalid &&
                membroForm.get('telefone').errors &&
                (membroForm.get('telefone').dirty ||
                  membroForm.get('telefone').touched)
              "
            >
              <small
                class="text-danger lovers-font--bold"
                *ngIf="membroForm.get('telefone').hasError('minlength')"
              >
                Telefone invalido
              </small>
            </div>
            <div
              class="pl-1"
              *ngIf="
                membroForm.get('telefone').invalid &&
                membroForm.get('telefone').errors &&
                (membroForm.get('telefone').dirty ||
                  membroForm.get('telefone').touched)
              "
            >
              <small
                class="text-danger lovers-font--bold"
                *ngIf="membroForm.get('telefone').hasError('required')"
              >
                Esse campo é obrigatório!
              </small>
            </div>

            <div class="mt-lg-4">
              <div class="lovers-input__container">
                <label for="email" class="lovers-label lovers-font--bold"
                  >E-MAIL</label
                >
                <input
                  type="email"
                  class="lovers-input input--ajust"
                  formControlName="email"
                  id="email"
                />
                <a
                  *ngIf="!membro.emailValidado"
                  class="label--cod mt-2 ml-1 font-ativa font-12 lovers-font--bold"
                  (click)="exibirPopupValidacaoDados(CAMPO_EMAIL)"
                >
                  <!-- <img
                    class="opcao__icone mr-1"
                    style="width: 10px; height: 14px"
                    src="assets/images/icons/checklist.png"
                  /> -->
                  Enviar código &nbsp;
                </a>
                <p
                  *ngIf="membro.emailValidado"
                  style="cursor: auto"
                  class="mt-2 ml-1 text-success font-14 lovers-font--bold"
                >
                  <i class="fa fa-check"></i> E-mail validado
                </p>
              </div>
              <div
                class="pl-1"
                *ngIf="
                  membroForm.get('email').invalid &&
                  membroForm.get('email').errors &&
                  (membroForm.get('email').dirty ||
                    membroForm.get('email').touched)
                "
              >
                <small
                  class="text-danger lovers-font--bold"
                  *ngIf="membroForm.get('email').hasError('required')"
                >
                  Esse campo é obrigatório!
                </small>
              </div>
              <div
                class="pl-1"
                *ngIf="
                  membroForm.get('email').invalid &&
                  membroForm.get('email').errors &&
                  (membroForm.get('email').dirty ||
                    membroForm.get('email').touched)
                "
              >
                <small
                  class="text-danger lovers-font--bold"
                  *ngIf="membroForm.get('email').hasError('pattern')"
                >
                  E-mail invalido
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col" *ngIf="!dadosvalidados">
            <button
              class="lovers-button-no-background"
              [disabled]="salvandoMembro"
              [ngClass]="{ 'lovers--disabled': salvandoMembro }"
              (click)="cancelar()"
            >
              Cancelar
              <i *ngIf="salvandoMembro" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>

          <div class="col">
            <button
              class="lovers-button"
              [disabled]="salvandoMembro"
              (click)="dadosValidadosSucesso()"
            >
              Finalizar
              <i *ngIf="salvandoMembro" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Modal Validação de Dados -->
      <lovers-popup
        [exibir]="exibirModalValidacaoDados"
        (onClose)="exibirModalValidacaoDados = false"
        tamanho="pequeno"
      >
        <div class="popup__header">
          <p class="header__title" style="text-transform: capitalize">
            {{ tituloModalGenerico }}
          </p>
        </div>
        <div class="popup__body">
          <div class="descricao">
            <h5
              *ngIf="!descricaoModalGenerico"
              class="lovers-font--bold"
              style="color: black"
            >
              Insira aqui o código enviado
            </h5>
            <h6 *ngIf="!descricaoModalGenerico">
              Enviamos o código para
              {{
                tituloModalGenerico == this.CAMPO_TELEFONE
                  ? (telefone | mask : "(00) 00000-0000")
                  : email
              }}
            </h6>
            <span
              *ngIf="descricaoModalGenerico"
              class="text-danger lovers-font--bold"
              >{{ descricaoModalGenerico }}</span
            >
            <div *ngIf="!descricaoModalGenerico" class="row mb-4 w-100">
              <ngx-otp-input
                [config]="otpInputConfig"
                (otpChange)="handeOtpChange($event)"
                (fill)="validarCodigo(tituloModalGenerico, $event)"
              >
              </ngx-otp-input>
            </div>
            <div class="row w-100">
              <div class="col-12 d-flex justify-content-center">
                <p class="mb-0">
                  <span
                    [innerHTML]="descricaoSegundosModalValidacaoDados"
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="popup__footer">
          <div class="footer__content d-flex justify-content-center">
            <button
              [disabled]="exibirBotaoReenviar"
              class="lovers-button"
              *ngIf="!descricaoModalGenerico && !exibirBotaoReenviar"
              (click)="exibirPopupValidacaoDados(tituloModalGenerico)"
            >
              Reenviar
            </button>
          </div>
        </div>
      </lovers-popup>
      <!-- Modal generico -->
      <lovers-popup
        [exibir]="exibirPopupGenerico"
        (onClose)="exibirPopupGenerico = false"
        tamanho="pequeno"
      >
        <div class="popup__header">
          <p class="header__title">{{ tituloModalGenerico }}</p>
        </div>
        <div class="popup__body">
          <div class="descricao">
            <h6 class="mb-0">
              <span [innerHtml]="descricaoModalGenerico"></span>
            </h6>
            <!-- <h6>{{descricaoPlusModalGenerico}}</h6> -->
          </div>
        </div>
        <div class="popup__footer">
          <div class="footer__content d-flex justify-content-center">
            <button class="lovers-button" (click)="exibirPopupGenerico = false">
              {{ descricaoBotaoModalGenerico }}
            </button>
          </div>
        </div>
      </lovers-popup>
    </form>
  </div>

  <img
    src="assets/images/backgrounds/background-novaSenha.png"
    class="background__image"
  />
  <img
    src="assets/images/backgrounds/background-novaSenha-mobile.png"
    class="background__image-mobile"
  />
</div>
